<template>
  <div class="box">
    <table class="table is-fullwidth" v-show="!loading && docs.length > 0">
      <thead>
        <tr>
          <th>Request Date</th>
          <th>Employee ID</th>
          <th>From</th>
          <th>To</th>
          <th>Name</th>
          <th>Mobile</th>
          <th>Email</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="misc in docs" :key="misc._id">
          <td>{{ misc.createdAt | date }}<p>{{ misc.createdAt | time }}</p></td>
          <td>{{ misc.employeeId }}</td>
          <td>{{ misc.startDate | date }}</p></td>
          <td>{{ misc.endDate | date }}</p></td>
          <td>{{ misc.name }}</td>
          <td>{{ misc.mobile }}</td>
          <td>{{ misc.email }}</td>
          <td class="actions">
            <router-link :to="`/request/misc/view/${misc._id}`">View</router-link>
            <router-link :to="`/request/misc/edit/${misc._id}`">Edit</router-link>
            <router-link :to="`/request/misc/delete/${misc._id}`" class="has-text-danger">Delete</router-link>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="has-text-centered">
      <button class="button is-loading is-large" v-show="loading"></button>
      <p
        class="has-text-grey"
        v-show="!loading && docs.length === 0"
      >No records matching these criteria</p>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    docs() {
      let component = this;
      return component.$store.getters["misc/docs"];
    },
    loading() {
      let component = this;
      return component.$store.getters["misc/loading"];
    }
  },
  mounted() {
    let component = this;
    component.$store.dispatch("misc/index");
  }
};
</script>
<style lang="scss" scoped>
.actions {
  a {
    padding-right: 16px;
  }
}
button.is-loading {
  border: none;
}
</style>
